import React, { useState, useEffect, useRef } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useLocation } from "react-router-dom";
import Layout from "../components/layoutBlack";
import { useSelector, useDispatch } from "react-redux";
import CheckoutForm from "../components/checkoutform";
import { config } from "../utils/constants";
import axios from "axios";
import { setCartData } from "../store/slices/cartSlice.ts"; 


const stripePromise = loadStripe(
  config.url.STRIPE_PUBLIC_KEY
);

const Payment = () => {
  const { state } = useLocation();

  const dispatch = useDispatch();
  const discountCode = useSelector((state) => state.cart.discount_code);
  const [clientSecret, setClientSecret] = useState("");
  const [selectedRate, setSelectedRate] = useState("");
  const [chargeAmount, setChargeAmount] = useState("");
  const [appliedPromotionCode, setAppliedPromotionCode] = useState("");
  const dataFetchedRef = useRef(false);
  const REACT_APP_API_URL = config.url.REACT_APP_API_URL;
  const { billingInfo, rates_id } = state;

  const cartItems = useSelector((state) => state.cart.items);
  const total = useSelector((state) => state.cart.total_price);
  const updated_rates_id = useSelector((state) => state.cart.rates_id);
  const subtotal = useSelector((state) => state.cart.subtotal);
  const shipping_price_paid = useSelector((state) => state.cart.shipping_price);
  const discount_value = useSelector((state) => state.cart.discount_value);
  
      useEffect(() => {
          window.scrollTo(0, 0);
      }, []);
      
  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    if (!state) {
      return <div className="container mt-5">Missing payment data.</div>;
    }
  // Avoid hitting API twice
  if (dataFetchedRef.current) return;
  dataFetchedRef.current = true;

    //prevent hitting API twice when page loads
    axios({
      method: "post",
      url: `${REACT_APP_API_URL}/create-payment-intent/`,
      data: { 'email':billingInfo.email, 'discount_code': discountCode, 'rates_id': rates_id },
    }).then((res) => {
      setClientSecret(res.data.clientSecret);
      const rates_id_ = res.data.cart['rates_id'];
      setAppliedPromotionCode(res.data.appliedPromotionCode);
      setSelectedRate(res.data.cart.rates_data[rates_id_]);
      setChargeAmount(parseFloat(res.data.chargeAmount).toFixed(2));
      dispatch(
        setCartData({
          items: res.data.cart.items,
          rates_id: rates_id_,
          subtotal: res.data.cart.subtotal,
          total_price: res.data.cart.total_price,
          discount_code: res.data.cart.discount_code,
          discount_amount: res.data.cart.discount_amount,
          discount_value: res.data.cart.discount_value,
          shipping_price: res.data.cart.shipping_price_paid,
          taxes: res.data.cart.taxes,
          carrier: res.data.cart.carrier,
          service_level: res.data.cart.service_level,
          box_length_inches: res.data.cart.box_length_inches,
          box_width_inches: res.data.cart.box_width_inches,
          box_height_inches: res.data.cart.box_height_inches,
          box_weight_ounces: res.data.cart.box_weight_ounces,
        })
      );
    });
  }, [cartItems, total, shipping_price_paid]);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };



  return (
    <Layout>
    <section className="full-page-section bg0 p-t-120 p-b-80">
      <div className="container">
        <div className="row isotope-grid">
        <section className="full-page-section bg0 py-5">
          <div className="container">
            <h2 className="mb-5 text-center">Secure Checkout</h2>
            <div className="row">
              
              {/* Left column: Credit Card Payment Form */}
              <div className="col-lg-6 mb-5">
                <div className="border rounded shadow-sm p-4 bg-white">
                  <h4 className="mb-4">Payment Details</h4>
                  {clientSecret && (
                    <Elements options={options} stripe={stripePromise}>
                      <CheckoutForm
                        charge_amount={parseFloat(chargeAmount).toFixed(2)}
                        shipping_amount={parseFloat(selectedRate.amount).toFixed(2)}
                        carrier = {selectedRate.provider}
                        service_level = {selectedRate.service_level}
                        email={billingInfo.email}
                        applied_promotion_code={appliedPromotionCode}
                        rates_id={updated_rates_id}
                      />
                    </Elements>
                  )}
                </div>
              </div>

              {/* Right column: Order Summary */}
              <div className="col-lg-6">
                <div className="border rounded shadow-sm p-4 bg-light mb-4">
                  <h5>Shipping Address</h5>
                  <p className="mb-1"><strong>{billingInfo.firstName} {billingInfo.lastName}</strong></p>
                  <p className="mb-1">{billingInfo.street1}</p>
                  {billingInfo.street2 && <p className="mb-1">{billingInfo.street2}</p>}
                  <p className="mb-1">{billingInfo.city}, {billingInfo.state} {billingInfo.zip}</p>
                  <p className="mb-1">{billingInfo.country}</p>
                  <p>{billingInfo.email}</p>
                </div>

                <div className="border rounded shadow-sm p-4 bg-light mb-4">
                  <h5>Shipping Method</h5>
                  <p className="mb-0">
                    {selectedRate.provider} - {selectedRate.service_level}
                  </p>
                </div>

                <div className="border rounded shadow-sm p-4 bg-light">
                  <h5>Order Summary</h5>
                  <ul className="list-group mb-3">
                    {cartItems.map((item) => (
                      <li className="list-group-item d-flex justify-content-between lh-sm" key={item.id}>
                        <div>
                          <h6 className="my-0">{item.name}</h6>
                          <small className="text-muted">Qty: {item.quantity}</small>
                        </div>
                        <span className="text-muted">${(item.price * item.quantity).toFixed(2)}</span>
                      </li>
                    ))}

                    <li className="list-group-item d-flex justify-content-between">
                      <span>Subtotal</span>
                      <strong>${subtotal.toFixed(2)}</strong>
                    </li>

                    <li className="list-group-item d-flex justify-content-between">
                      <span>Discount</span>
                      <strong className="text-success">-${parseFloat(discount_value).toFixed(2)}</strong>
                    </li>

                    <li className="list-group-item d-flex justify-content-between">
                      <span>Shipping</span>
                      <strong>${parseFloat(shipping_price_paid).toFixed(2)}</strong>
                    </li>

                    <li className="list-group-item d-flex justify-content-between">
                      <span>Total</span>
                      <strong>${total}</strong>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Payment;
